import getStore from '../store/store';
import { ObservableMap } from 'mobx';
import FolderTreeData from '../store/schema/FolderTreeData';

/**
 * Selector for folder tree table
 */
export default function getMailboxFolderTreeDataTable(): ObservableMap<string, FolderTreeData> {
    return getStore().folderTreeTable;
}
